import { useSelector } from 'react-redux';

// Store + Core
import { ITaxonomyTerm, OrganizationKind, OrganizationKinds } from 'core/models';
import { TAGS_ENUM } from 'core/constants';
import { navigationTermsSelector } from 'store/taxonomy/selectors';
import { organizationKindSelector } from 'store/user/selectors';

export const useTaxonomyHeaderNavTerms = (): ITaxonomyTerm[] => {
  const allNavItems: ITaxonomyTerm[] = useSelector(navigationTermsSelector);
  const defaultOrganization: OrganizationKind = useSelector(organizationKindSelector)?.organizationKind;
  // Only show taxonomy items in the nav if permissions are granted.
  return allNavItems.filter((item: ITaxonomyTerm) => {
    if (
      defaultOrganization !== OrganizationKinds.STAFF &&
      defaultOrganization !== OrganizationKinds.SPECIAL_ORGANIZATION
    ) {
      return item.tag !== TAGS_ENUM.STAFF;
    } else return item;
  });
};
